// extracted by mini-css-extract-plugin
export var personItem = "ArticlePersonBlock-module--personItem--1-P3k";
export var personOccupation = "ArticlePersonBlock-module--personOccupation--2hRjh";
export var personName = "ArticlePersonBlock-module--personName--1Ugy0";
export var personImage = "ArticlePersonBlock-module--personImage--1WuUF";
export var personBio = "ArticlePersonBlock-module--personBio--3cXnr";
export var personLinksHeading = "ArticlePersonBlock-module--personLinksHeading--308US";
export var personLinks = "ArticlePersonBlock-module--personLinks--32Yk2";